import { render, staticRenderFns } from "./CoregistrationBat.vue?vue&type=template&id=0e3830e1&scoped=true&"
import script from "./CoregistrationBat.vue?vue&type=script&lang=ts&"
export * from "./CoregistrationBat.vue?vue&type=script&lang=ts&"
import style0 from "./CoregistrationBat.vue?vue&type=style&index=0&id=0e3830e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3830e1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCard,VCol,VRow,VSpacer,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3830e1')) {
      api.createRecord('0e3830e1', component.options)
    } else {
      api.reload('0e3830e1', component.options)
    }
    module.hot.accept("./CoregistrationBat.vue?vue&type=template&id=0e3830e1&scoped=true&", function () {
      api.rerender('0e3830e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/CoregistrationBat.vue"
export default component.exports